// firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
    const firebaseConfig = {
      apiKey: "AIzaSyDY-iIdh6cMsgI1jDI40TRbq3sFq4I8uFo",
      authDomain: "apex-learning-solution.firebaseapp.com",
      projectId: "apex-learning-solution",
      storageBucket: "apex-learning-solution.firebasestorage.app",
      messagingSenderId: "467231731507",
      appId: "1:467231731507:web:8a63e95b4646e3ce675846",
      measurementId: "G-GES8ZCZHHZ"
    };

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)